export default __webpack_public_path__ + "static/media/customer-journey.c820a558.svg";